import React, { createContext, useContext, useState, useEffect } from 'react';
import en from './en';
import he from './he';

const langs = { en, he };

const I18nContext = createContext({
  t: k => k,
  dir: 'ltr',
  lang: 'en',
  setLang: () => {},
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('lr_lang') || 'en');

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem('lr_lang', l);
    document.documentElement.dir = l === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = l;
  };

  // Apply dir/lang on mount from persisted preference
  useEffect(() => {
    document.documentElement.dir = lang === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, []); // eslint-disable-line

  const t = (key, vars = {}) => {
    const str = langs[lang]?.[key] ?? langs.en?.[key] ?? key;
    return Object.entries(vars).reduce((s, [k, v]) => s.replace(`{${k}}`, v), str);
  };

  const dir = lang === 'he' ? 'rtl' : 'ltr';

  return (
    <I18nContext.Provider value={{ t, dir, lang, setLang }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
